import { collectExampleRows, collectLeafProperties, stringifyValue } from "./get-form-body-rows.js";
import { isObject } from "@scalar/helpers/object/is-object";
import { resolve } from "@scalar/workspace-store/resolve";
import { isObjectSchema } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/v2/blocks/request-block/helpers/get-structured-body-rows.ts
/**
* Build form-table rows for a structured (JSON/YAML) request body.
*
* The parsed body value is walked alongside the schema exactly like the multipart form
* editor does: schema-declared properties first in schema order (nested objects flatten
* into dotted-path leaves like `props.name`), example-only keys after in example order.
* Each row is enriched with its leaf schema so the table shows enum dropdowns, required
* badges, defaults, and validation per field.
*/
var getStructuredBodyRows = (parsedValue, schema) => {
	const objectSchema = schema && isObjectSchema(schema) ? schema : void 0;
	if (!isObject(parsedValue) && !objectSchema) return [];
	const leafByDottedName = /* @__PURE__ */ new Map();
	if (objectSchema) for (const leaf of collectLeafProperties(objectSchema)) leafByDottedName.set(leaf.path.join("."), leaf);
	const requiredSet = new Set(objectSchema?.required ?? []);
	return collectExampleRows(isObject(parsedValue) ? parsedValue : {}, objectSchema).map(({ path, value }) => {
		const name = path.join(".");
		const row = {
			name,
			value: value === void 0 || value === null ? "" : stringifyValue(value),
			isDisabled: false
		};
		const leaf = leafByDottedName.get(name);
		const propSchema = leaf?.schema ?? (objectSchema ? resolve.schema(objectSchema.properties?.[name]) : void 0);
		row.schema = propSchema;
		row.description = propSchema?.description;
		row.isRequired = leaf?.isRequired ?? requiredSet.has(name);
		return row;
	});
};
//#endregion
export { getStructuredBodyRows };

//# sourceMappingURL=get-structured-body-rows.js.map